import React, { useState } from "react";
import SelectSearchInputParam from "../../../edpOps/studentSerach/SelectSearchInputParam";
import PaymentCollectionHeader from "../../../masters/studentFinancials/paymentCollection/PaymentCollectionHeader";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import AInput from "../../../common/formFeilds/customInput/AInput";
import { getCookie } from "../../../common/utils/methods/commonMethods/utilityMethod";

const SingleStudentSearchCard = ({
  heading = "Search Students",
  searchHandler = () => {},
  crossHandler = () => {},
}) => {
  const [searchCriteria, setSearchCriteria] = useState("psid");
  const [inputVal, setInputVal] = useState("");

  const checkBoxChangeHandler = (newSearchCriteria) => {
    setInputVal("");
    setSearchCriteria(newSearchCriteria);
  };

  const isValidInput = () => {
    if (searchCriteria === "psid" && inputVal?.length !== 11) {
      failureToast("PSID must be 11 digits long!");
      return false;
    }

    if (searchCriteria === "applicationId" && inputVal?.length !== 8) {
      failureToast("Application Id must be 8 digits long!");
      return false;
    }
    return true;
  };

  const handleSearch = () => {
    isValidInput() &&
      searchHandler({
        [searchCriteria]: inputVal,
        opportunityOwnerId: getCookie("userId"),
      });
  };

  const handleCrossIconClick = () => {
    crossHandler();
    setInputVal("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      handleSearch();
    }
  };

  return (
    <div className="d-flex flex-column remove-container-top-space p-3 student-filer-container-printId">
      <PaymentCollectionHeader text={heading} />

      <SelectSearchInputParam
        searchInputParam={searchCriteria}
        setSearchInputParam={checkBoxChangeHandler}
        isHideName
      />

      <div style={{ width: "fit-content" }}>
        <AInput
          placeholder={`Search by ${
            searchCriteria === "psid" ? "PSID" : "Application ID"
          }`}
          style={{ height: "45px", width: "535px", marginTop: "4px" }}
          value={inputVal}
          handler={(val) => setInputVal(val)}
          onKeyDown={onKeyDown}
          crossIcon={true}
          rightSearchIcon={true}
          searchIconClickHandler={handleSearch}
          crossHandler={handleCrossIconClick}
          onKeyPress={(e) => {
            if (!/^[0-9]*$/.test(String.fromCharCode(e.charCode))) {
              e.preventDefault();
              return;
            }
          }}
          maxLength={searchCriteria === "psid" ? 11 : 8}
        />
      </div>
    </div>
  );
};

export default SingleStudentSearchCard;
